import { RootState } from "@/app/stores";
import { createSelector } from "@reduxjs/toolkit";

const baseSelector = createSelector(
    (state: RootState) => state.trading,
    (state) => state
)

export const selectPairs = createSelector(
    baseSelector,
    (state) => state.pairs
)
export const selectPairsFirstLoad = createSelector(
    baseSelector,
    (state) => state.isPairsFirstLoad
)
export const selectPairsLoading = createSelector(
    baseSelector,
    (state) => state.isPairsLoading
)
export const selectPairsError = createSelector(
    baseSelector,
    (state) => state.pairsError
)
export const selectTradingWallet = createSelector(
    baseSelector,
    (state) => state.wallet
)
export const selectTradingWalletFirstLoad = createSelector(
    baseSelector,
    (state) => state.isWalletFirstLoad
)
export const selectTradingWalletLoading = createSelector(
    baseSelector,
    (state) => state.isWalletLoading
)
export const selectTradingWalletError = createSelector(
    baseSelector,
    (state) => state.walletError
)